import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function TransferFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.07963 22.062C7.85133 22.1593 7.58848 22.1055 7.41371 21.9256L1.71024 16.0546C1.47159 15.809 1.47159 15.4107 1.71024 15.165L7.41371 9.29408C7.58848 9.11417 7.85133 9.06041 8.07963 9.15779C8.30801 9.25516 8.45687 9.48446 8.45687 9.73893V12.8841L12.5312 12.8841C13.0835 12.8841 13.5312 13.3318 13.5312 13.8841L13.5312 17.3357C13.5312 17.888 13.0834 18.3357 12.5312 18.3357H8.45687L8.45687 21.4808C8.45687 21.7352 8.30801 21.9646 8.07963 22.062Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.9126 1.93755C16.1409 1.84019 16.4037 1.894 16.5785 2.0739L22.2819 7.94487C22.5206 8.19052 22.5206 8.58883 22.2819 8.83448L16.5785 14.7054C16.4037 14.8853 16.1409 14.9391 15.9126 14.8417C15.6842 14.7444 15.5353 14.515 15.5353 14.2606V11.1154H11.461C10.9087 11.1154 10.4609 10.6677 10.461 10.1154L10.461 6.66383C10.461 6.11155 10.9087 5.66385 11.461 5.66385H15.5353V2.5187C15.5353 2.26428 15.6842 2.03491 15.9126 1.93755Z"
				fill="currentColor"
			/>
		</svg>
	);
}

TransferFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default TransferFilledIcon;
